import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import useWebviewInputFieldFocusBehavior from "@hooks/useWebviewInputFieldFocusBehavior";
import useBoolean from "@hooks/useBoolean";
import useIsMobile from "@hooks/useIsMobile";
import { useTabbyFinance } from "@/common/Contexts/TabbyFinanceContext";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { trackEvents } from "@/common/events/events";
import useCookieClient from "@hooks/useCookieClient";
import TabbyFormLayout from "@/pages/checkout/bnpl/tabby/components/TabbyFormLayout";
import TabbyFormContent from "@/pages/checkout/bnpl/tabby/components/TabbyFormContent";
import TabbyCancelPopup from "@/pages/checkout/bnpl/tabby/components/TabbyCancelPopup";
var TabbyForm = function TabbyForm() {
  if (__IS_SSR__) return null;
  useWebviewInputFieldFocusBehavior(110);
  var _useTabbyFinance$stat = useTabbyFinance().state,
    userInfo = _useTabbyFinance$stat.userInfo,
    orderData = _useTabbyFinance$stat.orderData,
    checkoutOrder = _useTabbyFinance$stat.checkoutOrder,
    fetch_loading = _useTabbyFinance$stat.fetch_loading;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTabbyFinance$quer = useTabbyFinance().queryParams,
    post_id = _useTabbyFinance$quer.post_id,
    financestep = _useTabbyFinance$quer.financestep;
  var grantedPopup = useBoolean();
  var isMobile = useIsMobile();
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useState = useState(financestep === 2 && !isLoggedIn),
    isOtpStep = _useState[0],
    setIsOtpStep = _useState[1];
  var _useState2 = useState(false),
    isOtpLoading = _useState2[0],
    setIsOtpLoading = _useState2[1];
  var _useState3 = useState(false),
    autosend = _useState3[0],
    setAutoSend = _useState3[1];
  var _useState4 = useState(false),
    showCancelPopup = _useState4[0],
    setShowCancelPopup = _useState4[1];
  var _useState5 = useState(false),
    hasUserStartedCheckoutForm = _useState5[0],
    setHasUserStartedCheckoutForm = _useState5[1];
  var isWebView = useIsWebView();
  var webview = useWebview();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  useEffect(function () {
    var _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2;
    if (!post_id || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.g4_data_layer)) return;
    if (hasUserStartedCheckoutForm) return;
    startAbandonmentTracking({
      key: "add_to_cart_completed_tabby_".concat(post_id),
      event: "add_to_cart_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, checkoutOrder.g4_data_layer), {}, {
        inventory_type: (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string,
        post_trim: (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_ext,
        booking_type: "tabby"
      })
    });
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    var _checkoutOrder$g4_dat3, _checkoutOrder$g4_dat4;
    if (!post_id || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.g4_data_layer) || !hasUserStartedCheckoutForm) return;
    completeAbandonmentTracking("add_to_cart_completed_tabby_".concat(post_id));
    startAbandonmentTracking({
      key: "start_checkout_abandoned_tabby_".concat(post_id),
      event: "start_checkout_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, checkoutOrder.g4_data_layer), {}, {
        inventory_type: (_checkoutOrder$g4_dat3 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat3 === void 0 ? void 0 : _checkoutOrder$g4_dat3.inventory_type_string,
        post_trim: (_checkoutOrder$g4_dat4 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat4 === void 0 ? void 0 : _checkoutOrder$g4_dat4.post_ext,
        booking_type: "tabby",
        last_completed_step: ""
      })
    });
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer, completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.reserved_status && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.reserved_status) !== 1) {
      return navigateTo("/cardetail/" + post_id);
    }
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.reserved_status, navigateTo, post_id]);
  var completeTabbyCheckoutAbandonmentTracking = function completeTabbyCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_tabby_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_tabby_".concat(post_id));
  };
  var handleCancelConfirm = function handleCancelConfirm() {
    setShowCancelPopup(false);
  };
  var handleCancelCancel = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _checkoutOrder$g4_dat5, _checkoutOrder$g4_dat6;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (orderData !== null && orderData !== void 0 && orderData.order_uuid) {
              setShowCancelPopup(false);
            }
            trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer) || {}), {}, {
              inventory_type: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat5 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat5 === void 0 ? void 0 : _checkoutOrder$g4_dat5.inventory_type_string,
              post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat6 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat6 === void 0 ? void 0 : _checkoutOrder$g4_dat6.post_ext,
              booking_type: "tabby"
            }));
            completeTabbyCheckoutAbandonmentTracking();
            navigateTo("/cardetail/".concat(post_id));
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCancelCancel() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(TabbyFormLayout, {
    checkoutOrder: checkoutOrder,
    fetch_loading: fetch_loading,
    fetch_error: null,
    orderData: orderData,
    isOtpStep: isOtpStep,
    isOtpLoading: isOtpLoading,
    showCancelPopup: showCancelPopup,
    onShowCancelPopup: function onShowCancelPopup() {
      return setShowCancelPopup(true);
    },
    onCancelPopupClose: function onCancelPopupClose() {
      return setShowCancelPopup(false);
    },
    onCancelPopupConfirm: handleCancelConfirm,
    onCancelPopupCancel: handleCancelCancel
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabbyFormContent, {
    checkoutOrder: checkoutOrder,
    fetch_loading: fetch_loading,
    userInfo: userInfo,
    isOtpStep: isOtpStep,
    isOtpLoading: isOtpLoading,
    setIsOtpLoading: setIsOtpLoading,
    autosend: autosend,
    setIsOtpStep: setIsOtpStep,
    setAutoSend: setAutoSend,
    onInfoIconClick: grantedPopup.setTrue,
    showCancelButton: !isMobile,
    onCancelButtonClick: function onCancelButtonClick() {
      return setShowCancelPopup(true);
    },
    onFormUpdated: setHasUserStartedCheckoutForm,
    onFormCompleted: completeTabbyCheckoutAbandonmentTracking
  }), !isWebView && /*#__PURE__*/React.createElement(TabbyCancelPopup, {
    show: showCancelPopup,
    onClose: function onClose() {
      return setShowCancelPopup(false);
    },
    onConfirm: handleCancelConfirm,
    onCancel: handleCancelCancel
  })));
};
export default TabbyForm;